<template>
  <div class="circle_l">
    <headd :mobile_title="mobile_title"></headd>

    <div class="circle">
      <div class="container">
        <!-- <uni-search-bar :radius="100" @confirm="getsearch" bgColor="#ffffff" placeholder="搜索你想要看的动态"></uni-search-bar> -->
        <div class="circle_list">
          <div
            class="circle_item"
            v-for="(item, index) in circle_list"
            :key="index"
            @click="getcircleDetail(item.title)"
            :data-id="item.title"
          >
            <div
              class="item_img"
              :style="{
                backgroundImage:
                  'url(' + (item.imgUrl != '' ? item.imgUrl : moren) + ')',
                backgroundSize: '222rpx 161rpx'
              }"
            >
              <img :src="item.imgUrl" />
            </div>
            <div class="item_info">
              <div class="info_1"># {{ item.title }}</div>
              <!-- <view class="info_2">10月1日直播间，和我们一起探索智慧农业经营新模式！</view> -->
              <div class="info_3">
                <div>{{ item.datanum }}条动态</div>
                <div>
                  {{ item.like_num }}喜欢
                  <img class="red" src="../../../static/circle/red.png" />
                </div>
                ️
              </div>
            </div>
          </div>
        </div>
        <div class="gomore" @click="morelist" v-show="!flag">加载更多</div>
      </div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
// import uniSearchBar from '@/components/uni-search-bar/uni-search-bar.vue'
import { getallCircleTopic } from "../api/api"; //引入api里面定义的方法
import headd from "@/components/head";
import foot from "@/components/foot";
export default {
  data() {
    return {
      mobile_title: "全部圈子",
      circle_list: [],
      pageindex: 1,
      flag: false,
      search: "",
      moren: "../../static/circle/icon_mr.png"
    };
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    headd,
    foot
  },
  mounted() {
    this.getCircle();
  },
  methods: {
    async getCircle() {
      var _slef = this;
      var data = {
        search: _slef.search,
        page: _slef.pageindex,
        limit: 5
      };
      const res = await getallCircleTopic(data);
      //console.log(res)

      _slef.circle_list = [..._slef.circle_list, ...res.data.data.alltopic];
      // _slef.circletrends = _slef.circletrends.concat(res.data.data.circletrends)

      if (res.data.data.alltopic.length < 5) {
        _slef.flag = true;
      }
    },
    getsearch(value) {
      console.log(value.value);
      this.search = value.value;
      (this.circle_list = []),
        (this.pageindex = 1),
        (this.flag = false),
        this.getCircle();
    },
    getcircleDetail(title) {
      this.$router.push({
        path: "circle_detail",
        query: {
          type: title
        }
      });
    },
    morelist() {
      if (!this.flag) {
        this.pageindex++;
        this.getCircle();
      }
    }
  }
};
</script>

<style lang="less" scoped>
page {
  background-color: #ffffff;
}
.circle_l {
  @media (max-width: 991px) {
    width: 6.86rem;
    margin: 0.3rem auto;
    .container {
      padding: 0;
    }
  }
}
.circle {
  padding: 0.32rem;
  flex-direction: column;
  @media (max-width: 991px) {
    padding: 0 0 0.32rem 0;
  }

  .circle_list {
    flex-direction: column;
    width: 8rem;
    margin: auto;
    @media (max-width: 991px) {
      width: 100%;
    }

    .circle_item {
      padding-bottom: 0.19rem;
      border-bottom: 0.01rem solid rgba(196, 196, 204, 0.2);
      border-radius: 0rem;
      display: flex;
      cursor: pointer;

      .item_img {
        width: 4.1rem;
        height: 2.3rem;
        border-radius: 0.12rem;
        margin-right: 0.32rem;
        background-position: center;
        @media (max-width: 991px) {
          width: 2.22rem;
          height: 1.6rem;
        }

        img {
          width: 100%;
          height: 100%;
          border-radius: 0.12rem;
          opacity: 0;
        }
      }

      .item_info {
        width: ~"calc(100% - 4.5rem)";
        flex-direction: column;
        text-align: left;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        @media (max-width: 991px) {
          width: ~"calc(100% - 3rem)";
        }

        .info_1 {
          margin-top: 0.07rem;
          font-size: 0.24rem;
          font-weight: bolder;
          color: #1b1c33;
          line-height: 0.33rem;
          margin-bottom: 0.25rem;
          @media (max-width: 991px) {
            font-size: 0.4rem;
            line-height: 0.6rem;
          }
        }

        .info_2 {
          font-size: 0.22rem;
          color: #8d8e99;
          line-height: 0.3rem;
          margin-bottom: 0.12rem;
        }

        .info_3 {
          font-size: 0.18rem;
          color: #c4c4cc;
          line-height: 0.25rem;
          display: flex;
          @media (max-width: 991px) {
            font-size: 0.28rem;
            line-height: 0.3rem;
          }

          div {
            margin-right: 0.4rem;

            ::last-child {
              margin-right: 0;
            }

            text {
              color: #ff545a;
            }
            .red {
              margin-left: 0.05rem;
              width: 0.2rem;
              height: 0.2rem;
              @media (max-width: 991px) {
                width: 0.3rem;
                height: 0.3rem;
              }
            }
          }
        }
      }

      margin-bottom: 0.3rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/circle/circle.vue